import React, { useEffect, useRef } from 'react';
import plusIcon from '../../assets/icons/plus-icon.svg';
import minusIcon from '../../assets/icons/minus-icon.svg';

interface Props {
  id: number;
  title: string;
  content: string;
}

const AccordionFAQ = (props: Props) => {
  const [isActive, setIsActive] = React.useState(false);
  let accordionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let onMouseUp = (e: MouseEvent) => {
      if (!accordionRef.current?.contains(e.target as Node)) {
        setIsActive(false);
      }
    };

    document.addEventListener('mouseup', onMouseUp);

    return () => {
      document.removeEventListener('mouseup', onMouseUp);
    };
  });

  return (
    <div
      ref={accordionRef}
      onClick={() => {
        if (!isActive) setIsActive(true);
      }}
      className={`accordion-faq-item ${isActive ? 'active' : ''}`}
    >
      <div className='accordion-faq-item__data'>
        <div className='accordion-faq-item__data__title'>
          <div className='accordion-faq-item__data__title__key'>#{props.id < 10 ? '0' + (props.id + 1) : props.id + 1}</div>
          <div className='accordion-faq-item__data__title__value'>{props.title}</div>
        </div>
        {isActive && <div className='accordion-faq-item__data__content'>{props.content}</div>}
      </div>

      <img
        className='accordion-faq-item__expand-icon'
        src={isActive ? minusIcon : plusIcon}
        alt='  '
        onClick={() => setIsActive((prevState) => !prevState)}
      />
      {/* <div>{isActive ? '-' : '+'}</div> */}
    </div>
  );
};

export default AccordionFAQ;
